module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//store-goods_limited_bg.png?v=6ea70984";